import './App.css';
import { useI18n } from './i18n/i18n';
import { Menu } from './Menu';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';


function App() {
    const i18n = useI18n();

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div className="App">
            <Menu i18n={i18n} />
            <main>
                <Outlet />
            </main>
        </div>
    );
}

export default App;
